module.exports = __webpack_public_path__ + "static/media/map_greenery.cc0fcd51.png";